import { render, staticRenderFns } from "./exchangeItemForm.vue?vue&type=template&id=15992868&scoped=true&"
import script from "./exchangeItemForm.vue?vue&type=script&lang=js&"
export * from "./exchangeItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15992868",
  null
  
)

export default component.exports